<script>
  let { assetsPath = '/', onAiMounted = () => {} } = $props();
  import { onMount } from 'svelte';
  onMount(() => {
    onAiMounted();
  });
</script>

<div id="g-base-map-box">
  <!-- Artboard: xs -->
  <div
    id="g-base-map-xs"
    class="g-artboard"
    style="display: none;aspect-ratio: 0.96774193548387;"
  >
    <div
      id="g-base-map-xs-img"
      class="g-aiImg"
      alt=""
      style="background-image: url({assetsPath.replace(
        new RegExp('/([^/.]+)$'),
        '/$1/'
      ) || '/'}images/graphics/base-map-xs.jpg);"
    ></div>
    <div
      id="g-ai0-1"
      class="g-XS_map g-aiAbs g-aiPointText"
      style="transform: matrix(0.993,0.1181,-0.1181,0.993,0,0);transform-origin: 50% 59.3048614266243%;-webkit-transform: matrix(0.993,0.1181,-0.1181,0.993,0,0);-webkit-transform-origin: 50% 59.3048614266243%;-ms-transform: matrix(0.993,0.1181,-0.1181,0.993,0,0);-ms-transform-origin: 50% 59.3048614266243%;top:23.8632%;margin-top:-5.4px;left:10.8872%;margin-left:-36px;width:72px;"
    >
      <p class="g-pstyle0">Turkey</p>
    </div>
    <div
      id="g-ai0-2"
      class="g-XS_map g-aiAbs g-aiPointText"
      style="top:38.8557%;margin-top:-5.5px;left:23.8027%;margin-left:-34px;width:68px;"
    >
      <p class="g-pstyle1">Syria</p>
    </div>
    <div
      id="g-ai0-3"
      class="g-XS_map g-aiAbs g-aiPointText"
      style="top:45.6006%;margin-top:-5.5px;left:7.7434%;margin-left:-34px;width:68px;"
    >
      <p class="g-pstyle2">Israel</p>
    </div>
    <div
      id="g-ai0-4"
      class="g-XS_map g-aiAbs g-aiPointText"
      style="top:48.2399%;margin-top:-5.5px;left:35.8015%;margin-left:-31.5px;width:63px;"
    >
      <p class="g-pstyle3">Iraq</p>
    </div>
    <div
      id="g-ai0-5"
      class="g-XS_map g-aiAbs g-aiPointText"
      style="top:50.9279%;margin-top:-5.7px;left:69.9179%;margin-left:-32.5px;width:65px;"
    >
      <p class="g-pstyle4">Iran</p>
    </div>
    <div
      id="g-ai0-6"
      class="g-XS_map g-aiAbs g-aiPointText"
      style="top:72.5922%;margin-top:-16.5px;left:35.8174%;margin-left:-46px;width:92px;"
    >
      <p class="g-pstyle5">Saudi</p>
      <p class="g-pstyle5">Arabia</p>
    </div>
    <div
      id="g-ai0-7"
      class="g-XS_map g-aiAbs g-aiPointText"
      style="top:79.0073%;margin-top:-11.4px;left:86.4142%;width:62px;"
    >
      <p class="g-pstyle6">Gulf of</p>
      <p class="g-pstyle6">Oman</p>
    </div>
  </div>

  <!-- Artboard: sm -->
  <div
    id="g-base-map-sm"
    class="g-artboard"
    style="display: none;aspect-ratio: 1.08050847457627;"
  >
    <div
      id="g-base-map-sm-img"
      class="g-aiImg"
      alt=""
      style="background-image: url({assetsPath.replace(
        new RegExp('/([^/.]+)$'),
        '/$1/'
      ) || '/'}images/graphics/base-map-sm.jpg);"
    ></div>
    <div
      id="g-ai1-1"
      class="g-SM_map g-aiAbs g-aiPointText"
      style="transform: matrix(0.993,0.1181,-0.1181,0.993,0,0);transform-origin: 50% 56.5575870129038%;-webkit-transform: matrix(0.993,0.1181,-0.1181,0.993,0,0);-webkit-transform-origin: 50% 56.5575870129038%;-ms-transform: matrix(0.993,0.1181,-0.1181,0.993,0,0);-ms-transform-origin: 50% 56.5575870129038%;top:23.6493%;margin-top:-7.6px;left:12.6647%;margin-left:-45px;width:90px;"
    >
      <p class="g-pstyle0">Turkey</p>
    </div>
    <div
      id="g-ai1-2"
      class="g-SM_map g-aiAbs g-aiPointText"
      style="top:41.3946%;margin-top:-7.4px;left:24.0209%;margin-left:-30px;width:60px;"
    >
      <p class="g-pstyle1">Syria</p>
    </div>
    <div
      id="g-ai1-3"
      class="g-SM_map g-aiAbs g-aiPointText"
      style="top:47.2027%;margin-top:-7.8px;left:8.049%;margin-left:-34.5px;width:69px;"
    >
      <p class="g-pstyle2">Israel</p>
    </div>
    <div
      id="g-ai1-4"
      class="g-SM_map g-aiAbs g-aiPointText"
      style="top:49.4968%;margin-top:-7.6px;left:36.2646%;margin-left:-32px;width:64px;"
    >
      <p class="g-pstyle0">Iraq</p>
    </div>
    <div
      id="g-ai1-5"
      class="g-SM_map g-aiAbs g-aiPointText"
      style="transform: matrix(0.5767,-0.817,0.817,0.5767,0,0);transform-origin: 50% 56.6945606694561%;-webkit-transform: matrix(0.5767,-0.817,0.817,0.5767,0,0);-webkit-transform-origin: 50% 56.6945606694561%;-ms-transform: matrix(0.5767,-0.817,0.817,0.5767,0,0);-ms-transform-origin: 50% 56.6945606694561%;top:54.3366%;margin-top:-7.5px;left:16.2122%;margin-left:-32.5px;width:65px;"
    >
      <p class="g-pstyle3">Jordan</p>
    </div>
    <div
      id="g-ai1-6"
      class="g-SM_map g-aiAbs g-aiPointText"
      style="top:52.8137%;margin-top:-8.3px;left:67.7399%;margin-left:-34px;width:68px;"
    >
      <p class="g-pstyle4">Iran</p>
    </div>
    <div
      id="g-ai1-7"
      class="g-SM_map g-aiAbs g-aiPointText"
      style="top:74.5335%;margin-top:-14.8px;left:36.2799%;margin-left:-44px;width:88px;"
    >
      <p class="g-pstyle0">Saudi</p>
      <p class="g-pstyle0">Arabia</p>
    </div>
    <div
      id="g-ai1-8"
      class="g-SM_map g-aiAbs g-aiPointText"
      style="top:81.6554%;margin-top:-12.4px;left:84.154%;width:65px;"
    >
      <p class="g-pstyle5">Gulf of</p>
      <p class="g-pstyle5">Oman</p>
    </div>
  </div>

  <!-- Artboard: md -->
  <div
    id="g-base-map-md"
    class="g-artboard"
    style="display: none;aspect-ratio: 1.46341463414634;"
  >
    <div
      id="g-base-map-md-img"
      class="g-aiImg"
      alt=""
      style="background-image: url({assetsPath.replace(
        new RegExp('/([^/.]+)$'),
        '/$1/'
      ) || '/'}images/graphics/base-map-md.jpg);"
    ></div>
    <div
      id="g-ai2-1"
      class="g-MD_map g-aiAbs g-aiPointText"
      style="transform: matrix(0.993,0.1181,-0.1181,0.993,0,0);transform-origin: 50% 54.9192928516526%;-webkit-transform: matrix(0.993,0.1181,-0.1181,0.993,0,0);-webkit-transform-origin: 50% 54.9192928516526%;-ms-transform: matrix(0.993,0.1181,-0.1181,0.993,0,0);-ms-transform-origin: 50% 54.9192928516526%;top:17.1095%;margin-top:-10.2px;left:14.2617%;margin-left:-55.5px;width:111px;"
    >
      <p class="g-pstyle0">Turkey</p>
    </div>
    <div
      id="g-ai2-2"
      class="g-MD_map g-aiAbs g-aiPointText"
      style="top:41.2505%;margin-top:-10px;left:25.7559%;margin-left:-36px;width:72px;"
    >
      <p class="g-pstyle1">Syria</p>
    </div>
    <div
      id="g-ai2-3"
      class="g-MD_map g-aiAbs g-aiPointText"
      style="top:49.3528%;margin-top:-10.6px;left:9.5564%;margin-left:-41.5px;width:83px;"
    >
      <p class="g-pstyle2">Israel</p>
    </div>
    <div
      id="g-ai2-4"
      class="g-MD_map g-aiAbs g-aiPointText"
      style="top:52.3645%;margin-top:-10.2px;left:38.0362%;margin-left:-38px;width:76px;"
    >
      <p class="g-pstyle0">Iraq</p>
    </div>
    <div
      id="g-ai2-5"
      class="g-MD_map g-aiAbs g-aiPointText"
      style="transform: matrix(0.5767,-0.817,0.817,0.5767,0,0);transform-origin: 50% 55.0009767532721%;-webkit-transform: matrix(0.5767,-0.817,0.817,0.5767,0,0);-webkit-transform-origin: 50% 55.0009767532721%;-ms-transform: matrix(0.5767,-0.817,0.817,0.5767,0,0);-ms-transform-origin: 50% 55.0009767532721%;top:58.9796%;margin-top:-10px;left:17.8224%;margin-left:-39px;width:78px;"
    >
      <p class="g-pstyle3">Jordan</p>
    </div>
    <div
      id="g-ai2-6"
      class="g-MD_map g-aiAbs g-aiPointText"
      style="top:56.9467%;margin-top:-10.8px;left:71.2673%;margin-left:-41px;width:82px;"
    >
      <p class="g-pstyle4">Iran</p>
    </div>
    <div
      id="g-ai2-7"
      class="g-MD_map g-aiAbs g-aiPointText"
      style="top:86.5956%;margin-top:-19.5px;left:38.0981%;margin-left:-54px;width:108px;"
    >
      <p class="g-pstyle0">Saudi</p>
      <p class="g-pstyle0">Arabia</p>
    </div>
  </div>

  <!-- Artboard: lg -->
  <div
    id="g-base-map-lg"
    class="g-artboard"
    style="display: none;aspect-ratio: 1.74812030075188;"
  >
    <div
      id="g-base-map-lg-img"
      class="g-aiImg"
      alt=""
      style="background-image: url({assetsPath.replace(
        new RegExp('/([^/.]+)$'),
        '/$1/'
      ) || '/'}images/graphics/base-map-lg.jpg);"
    ></div>
    <div
      id="g-ai3-1"
      class="g-Country_labels g-aiAbs g-aiPointText"
      style="transform: matrix(0.8924,0.4512,-0.4512,0.8924,0,0);transform-origin: 50% 54.9597985081856%;-webkit-transform: matrix(0.8924,0.4512,-0.4512,0.8924,0,0);-webkit-transform-origin: 50% 54.9597985081856%;-ms-transform: matrix(0.8924,0.4512,-0.4512,0.8924,0,0);-ms-transform-origin: 50% 54.9597985081856%;top:14.301%;margin-top:-10.1px;left:76.5781%;margin-left:-63px;width:126px;"
    >
      <p class="g-pstyle0">Uzbekistan</p>
    </div>
    <div
      id="g-ai3-2"
      class="g-Country_labels g-aiAbs g-aiPointText"
      style="transform: matrix(0.993,0.1181,-0.1181,0.993,0,0);transform-origin: 50% 54.9597985081856%;-webkit-transform: matrix(0.993,0.1181,-0.1181,0.993,0,0);-webkit-transform-origin: 50% 54.9597985081856%;-ms-transform: matrix(0.993,0.1181,-0.1181,0.993,0,0);-ms-transform-origin: 50% 54.9597985081856%;top:23.8874%;margin-top:-10.1px;left:22.2215%;margin-left:-43px;width:86px;"
    >
      <p class="g-pstyle0">Turkey</p>
    </div>
    <div
      id="g-ai3-3"
      class="g-Country_labels g-aiAbs g-aiPointText"
      style="transform: matrix(0.9599,0.2805,-0.2805,0.9599,0,0);transform-origin: 50% 54.9597985081856%;-webkit-transform: matrix(0.9599,0.2805,-0.2805,0.9599,0,0);-webkit-transform-origin: 50% 54.9597985081856%;-ms-transform: matrix(0.9599,0.2805,-0.2805,0.9599,0,0);-ms-transform-origin: 50% 54.9597985081856%;top:27.8348%;margin-top:-10.1px;left:71.3167%;margin-left:-76px;width:152px;"
    >
      <p class="g-pstyle0">Turkmenistan</p>
    </div>
    <div
      id="g-ai3-4"
      class="g-Cities g-aiAbs g-aiPointText"
      style="top:32.9884%;margin-top:-6.5px;left:46.8415%;width:52px;"
    >
      <p class="g-pstyle1">Tabriz</p>
    </div>
    <div
      id="g-ai3-5"
      class="g-Cities g-aiAbs g-aiPointText"
      style="top:39.5673%;margin-top:-6.5px;left:66.1877%;width:69px;"
    >
      <p class="g-pstyle1">Mashhad</p>
    </div>
    <div
      id="g-ai3-6"
      class="g-Cities g-aiAbs g-aiPointText"
      style="top:43.3423%;margin-top:-7.6px;left:56.8368%;width:62px;"
    >
      <p class="g-pstyle2">Tehran</p>
    </div>
    <div
      id="g-ai3-7"
      class="g-Country_labels g-aiAbs g-aiPointText"
      style="top:44.1882%;margin-top:-10.1px;left:30.3689%;margin-left:-35px;width:70px;"
    >
      <p class="g-pstyle0">Syria</p>
    </div>
    <div
      id="g-ai3-8"
      class="g-Cities g-aiAbs g-aiPointText"
      style="top:46.8981%;margin-top:-6.5px;left:50.8153%;width:71px;"
    >
      <p class="g-pstyle1">Hamadan</p>
    </div>
    <div
      id="g-ai3-9"
      class="g-Country_labels g-aiAbs g-aiPointText"
      style="top:50.2032%;margin-top:-10.1px;left:83.2287%;margin-left:-70px;width:140px;"
    >
      <p class="g-pstyle0">Afghanistan</p>
    </div>
    <div
      id="g-ai3-10"
      class="g-Country_labels g-aiAbs g-aiPointText"
      style="top:50.7043%;margin-top:-10.7px;left:18.8623%;margin-left:-50px;width:100px;"
    >
      <p class="g-pstyle3">Israel</p>
    </div>
    <div
      id="g-ai3-11"
      class="g-Country_labels g-aiAbs g-aiPointText"
      style="top:53.7746%;margin-top:-10.1px;left:39.1075%;margin-left:-30.5px;width:61px;"
    >
      <p class="g-pstyle0">Iraq</p>
    </div>
    <div
      id="g-ai3-12"
      class="g-Country_labels g-aiAbs g-aiPointText"
      style="transform: matrix(0.5767,-0.817,0.817,0.5767,0,0);transform-origin: 50% 55.0009767532721%;-webkit-transform: matrix(0.5767,-0.817,0.817,0.5767,0,0);-webkit-transform-origin: 50% 55.0009767532721%;-ms-transform: matrix(0.5767,-0.817,0.817,0.5767,0,0);-ms-transform-origin: 50% 55.0009767532721%;top:59.3981%;margin-top:-10px;left:24.7509%;margin-left:-39px;width:78px;"
    >
      <p class="g-pstyle4">Jordan</p>
    </div>
    <div
      id="g-ai3-13"
      class="g-Country_labels g-aiAbs g-aiPointText"
      style="top:59.5389%;margin-top:-10.7px;left:63.538%;margin-left:-38px;width:76px;"
    >
      <p class="g-pstyle3">Iran</p>
    </div>
    <div
      id="g-ai3-14"
      class="g-Cities g-aiAbs g-aiPointText"
      style="top:68.5147%;margin-top:-6.5px;left:59.0889%;width:54px;"
    >
      <p class="g-pstyle1">Shiraz</p>
    </div>
    <div
      id="g-ai3-15"
      class="g-Country_labels g-aiAbs g-aiPointText"
      style="top:73.1355%;margin-top:-10.1px;left:87.7767%;margin-left:-51.5px;width:103px;"
    >
      <p class="g-pstyle0">Pakistan</p>
    </div>
    <div
      id="g-ai3-16"
      class="g-Country_labels g-aiAbs g-aiPointText"
      style="top:82.7938%;margin-top:-19.5px;left:39.1278%;margin-left:-41.5px;width:83px;"
    >
      <p class="g-pstyle0">Saudi</p>
      <p class="g-pstyle0">Arabia</p>
    </div>
    <div
      id="g-ai3-17"
      class="g-Water_labels g-aiAbs g-aiPointText"
      style="top:88.4395%;margin-top:-14.5px;left:69.4065%;width:71px;"
    >
      <p class="g-pstyle5">Gulf of</p>
      <p class="g-pstyle5">Oman</p>
    </div>
  </div>
</div>
<!-- End ai2html - 2025-06-16 12:21 -->

<!-- Generated by ai2html v0.101.0 - 2025-06-16 12:21 -->
<!-- ai file: base-map.ai -->
<style lang="scss">
  #g-base-map-box,
  #g-base-map-box .g-artboard {
    margin: 0 auto;
  }
  #g-base-map-box p {
    margin: 0;
  }
  #g-base-map-box .g-aiAbs {
    position: absolute;
  }
  #g-base-map-box .g-aiImg {
    position: absolute;
    top: 0;
    display: block;
    width: 100% !important;
    height: 100%;
    background-size: contain;
    background-repeat: no-repeat;
  }
  #g-base-map-box .g-aiPointText p {
    white-space: nowrap;
  }
  #g-base-map-box {
    container-type: inline-size;
    @container (min-width:0px) and (max-width: 509px) {
      #g-base-map-xs {
        display: block !important;
      }
    }
    @container (min-width:510px) and (max-width: 659px) {
      #g-base-map-sm {
        display: block !important;
      }
    }
    @container (min-width:660px) and (max-width: 929px) {
      #g-base-map-md {
        display: block !important;
      }
    }
    @container (min-width:930px) {
      #g-base-map-lg {
        display: block !important;
      }
    }
  }
  #g-base-map-xs {
    position: relative;
    overflow: hidden;
  }
  #g-base-map-xs p {
    font-family: 'Knowledge', 'Source Sans Pro', Arial, sans-serif;
    font-weight: 400;
    line-height: 16px;
    height: auto;
    opacity: 1;
    letter-spacing: 0.4em;
    font-size: 13px;
    text-align: left;
    text-transform: none;
    color: rgb(136, 136, 136);
    padding-bottom: 0;
    padding-top: 0;
    mix-blend-mode: normal;
    font-style: normal;
    position: static;
  }
  #g-base-map-xs .g-pstyle0 {
    line-height: 10px;
    height: 10px;
    opacity: 0.5;
    font-size: 9px;
    text-align: center;
    text-transform: uppercase;
  }
  #g-base-map-xs .g-pstyle1 {
    line-height: 10px;
    height: 10px;
    opacity: 0.5;
    letter-spacing: 0.3em;
    font-size: 12px;
    text-align: center;
    text-transform: uppercase;
  }
  #g-base-map-xs .g-pstyle2 {
    font-weight: 900;
    line-height: 10px;
    height: 10px;
    letter-spacing: 0.1em;
    font-size: 12px;
    text-align: center;
    text-transform: uppercase;
  }
  #g-base-map-xs .g-pstyle3 {
    line-height: 10px;
    height: 10px;
    opacity: 0.5;
    font-size: 12px;
    text-align: center;
    text-transform: uppercase;
  }
  #g-base-map-xs .g-pstyle4 {
    font-weight: 900;
    line-height: 10px;
    height: 10px;
    letter-spacing: 0.1em;
    font-size: 16px;
    text-align: center;
    text-transform: uppercase;
  }
  #g-base-map-xs .g-pstyle5 {
    height: 16px;
    opacity: 0.5;
    text-align: center;
    text-transform: uppercase;
  }
  #g-base-map-xs .g-pstyle6 {
    font-weight: 500;
    line-height: 11px;
    height: 11px;
    opacity: 0.6;
    letter-spacing: 0.2em;
    font-size: 10px;
    color: rgb(153, 153, 153);
  }
  #g-base-map-sm {
    position: relative;
    overflow: hidden;
  }
  #g-base-map-sm p {
    font-family: 'Knowledge', 'Source Sans Pro', Arial, sans-serif;
    font-weight: 400;
    line-height: 14px;
    height: auto;
    opacity: 1;
    letter-spacing: 0.4em;
    font-size: 12px;
    text-align: left;
    text-transform: none;
    color: rgb(136, 136, 136);
    padding-bottom: 0;
    padding-top: 0;
    mix-blend-mode: normal;
    font-style: normal;
    position: static;
  }
  #g-base-map-sm .g-pstyle0 {
    height: 14px;
    opacity: 0.5;
    text-align: center;
    text-transform: uppercase;
  }
  #g-base-map-sm .g-pstyle1 {
    height: 14px;
    opacity: 0.5;
    letter-spacing: 0.3em;
    font-size: 10px;
    text-align: center;
    text-transform: uppercase;
  }
  #g-base-map-sm .g-pstyle2 {
    font-weight: 900;
    line-height: 15px;
    height: 15px;
    letter-spacing: 0.2em;
    font-size: 11px;
    text-align: center;
    text-transform: uppercase;
  }
  #g-base-map-sm .g-pstyle3 {
    height: 14px;
    opacity: 0.5;
    letter-spacing: 0.2em;
    font-size: 9px;
    text-align: center;
    text-transform: uppercase;
  }
  #g-base-map-sm .g-pstyle4 {
    font-weight: 900;
    line-height: 15px;
    height: 15px;
    letter-spacing: 0.2em;
    font-size: 15px;
    text-align: center;
    text-transform: uppercase;
  }
  #g-base-map-sm .g-pstyle5 {
    font-weight: 500;
    line-height: 12px;
    height: 12px;
    opacity: 0.6;
    letter-spacing: 0.2em;
    font-size: 11px;
    color: rgb(153, 153, 153);
  }
  #g-base-map-md {
    position: relative;
    overflow: hidden;
  }
  #g-base-map-md p {
    font-family: 'Knowledge', 'Source Sans Pro', Arial, sans-serif;
    font-weight: 400;
    line-height: 19px;
    height: auto;
    opacity: 1;
    letter-spacing: 0.4em;
    font-size: 16px;
    text-align: left;
    text-transform: none;
    color: rgb(136, 136, 136);
    padding-bottom: 0;
    padding-top: 0;
    mix-blend-mode: normal;
    font-style: normal;
    position: static;
  }
  #g-base-map-md .g-pstyle0 {
    height: 19px;
    opacity: 0.5;
    text-align: center;
    text-transform: uppercase;
  }
  #g-base-map-md .g-pstyle1 {
    height: 19px;
    opacity: 0.5;
    letter-spacing: 0.3em;
    font-size: 13px;
    text-align: center;
    text-transform: uppercase;
  }
  #g-base-map-md .g-pstyle2 {
    font-weight: 900;
    line-height: 20px;
    height: 20px;
    letter-spacing: 0.2em;
    font-size: 14px;
    text-align: center;
    text-transform: uppercase;
  }
  #g-base-map-md .g-pstyle3 {
    height: 19px;
    opacity: 0.5;
    letter-spacing: 0.2em;
    font-size: 12px;
    text-align: center;
    text-transform: uppercase;
  }
  #g-base-map-md .g-pstyle4 {
    font-weight: 900;
    line-height: 20px;
    height: 20px;
    letter-spacing: 0.2em;
    font-size: 20px;
    text-align: center;
    text-transform: uppercase;
  }
  #g-base-map-lg {
    position: relative;
    overflow: hidden;
  }
  #g-base-map-lg p {
    font-family: 'Knowledge', 'Source Sans Pro', Arial, sans-serif;
    font-weight: 400;
    line-height: 19px;
    height: auto;
    opacity: 1;
    letter-spacing: 0.2em;
    font-size: 14px;
    text-align: left;
    text-transform: none;
    color: rgb(182, 168, 159);
    padding-bottom: 0;
    padding-top: 0;
    mix-blend-mode: normal;
    font-style: normal;
    position: static;
  }
  #g-base-map-lg .g-pstyle0 {
    height: 19px;
    text-align: center;
    text-transform: uppercase;
  }
  #g-base-map-lg .g-pstyle1 {
    line-height: 12px;
    height: 12px;
    letter-spacing: 0em;
    font-size: 12px;
    color: rgb(64, 64, 64);
  }
  #g-base-map-lg .g-pstyle2 {
    line-height: 14px;
    height: 14px;
    letter-spacing: 0em;
    color: rgb(64, 64, 64);
  }
  #g-base-map-lg .g-pstyle3 {
    font-weight: 900;
    line-height: 20px;
    height: 20px;
    font-size: 18px;
    text-align: center;
    text-transform: uppercase;
    color: rgb(102, 102, 102);
  }
  #g-base-map-lg .g-pstyle4 {
    height: 19px;
    opacity: 0.5;
    font-size: 12px;
    text-align: center;
    text-transform: uppercase;
    color: rgb(136, 136, 136);
  }
  #g-base-map-lg .g-pstyle5 {
    font-weight: 500;
    line-height: 14px;
    height: 14px;
    opacity: 0.6;
    font-size: 12px;
    color: rgb(153, 153, 153);
  }

  /* Custom CSS */
  .g-text {
  }
</style>
